import { useContext, useEffect, useState } from 'react';
import { Card, CardBody, Col, Form, Input, Label, Row } from 'reactstrap';
import { DateFormateChange, isEmpty, maxLengthCheck, randomStr, toCamelCase } from '../../utils/helper';
import './PublicPage.css';
import { Donation_MasterList_Public } from '../../api/DonationMasterApi/DonationMasterApi';
import { ACCOUNT_TYPE, CLIENT_TYPE } from '../../constant';
import { toast, Zoom } from 'react-toastify';
import { FILE_API } from '../../api/Bank Master api/BankMasterAPi';
import {
  CreateTrasectionDueSlip_Public,
  Donation_bill_Details_Public
} from '../../api/DonationBillApi/DonationCillapi';
import { useNavigate, useParams } from 'react-router';
import LoaderResoinse from '../../loader/loader';
import DonarPublicHeaderComponent from '../../common/commonComp';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DialCodeList } from '../../api/DialCodeApi/DialCodeApi';
import DonationMahotsavContext from '../../context/DonationMahotsavContext/DonationMahotsavContext';
import { Plus } from 'react-feather';
import CustomLoader from '../../loader/CustomLoader';

const DonationMahotsavType = () => {
  const {
    setAddress,
    name,
    setName,
    date,
    setDate,
    contactNo,
    setContactNo,
    village,
    setVillage,
    setPanCard,
    setAadhaarCard,
    byHand,
    setByhand,
    city,
    setCity,
    state,
    setState,
    setCountry,
    personId,
    setPersonaId,
    setTrustId,
    note,
    setNote,
    transectionNo,
    setTransectionNo,
    dialCode,
    setDialCode
  } = useContext(DonationMahotsavContext);
  const [maxUnit, setMaxUnit] = useState(10);

  const [feilds, setFeilds] = useState([
    {
      id: randomStr(5),
      accountId: Number(null),
      amount: Number(null),
      name: null,
      totalAmount: Number(null),
      unit: null,
      unitValue: Number(1)
    }
  ]);

  const history = useNavigate();
  const [click, setClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialCodeJson, setDialCodeJson] = useState([]);
  const { bankId, trustUuid, orgId, templeUuid, accontId } = useParams();

  const handleInputChange = (i, e) => {
    const values = [...feilds];
    values[i][e.target.name] = e.target.value;
    setFeilds(values);
  };

  const accountDropDown = async () => {
    let paramsObj = {
      search: { type: ACCOUNT_TYPE.inward, isActive: true, accountId: accontId },
      trustUuid: trustUuid,
      templeUuid,
      showAll: true
    };
    setLoading(true);
    try {
      const { data } = await Donation_MasterList_Public(paramsObj);
      if (data.status === 200) {
        setFeilds((prev) => {
          const updated = [...prev];
          updated[0] = {
            ...updated[0],
            accountId: data.payload.data[0].accountId,
            amount: Number(data.payload.data[0].defaultAmount),
            totalAmount: Number(data.payload.data[0].defaultAmount),
            name: data.payload.data[0].name,
            unit: data.payload.data[0].unit,
            unitValue: data.payload.data[0].unitValue
          };
          return updated;
        });
        setNote(
          1 +
            ' ' +
            data.payload.data[0].unit +
            ' ' +
            data.payload.data[0].name +
            ' ના ' +
            Number(data.payload.data[0].defaultAmount)
        );
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    accountDropDown();
    setDialCodeJson(DialCodeList());
  }, []);

  const showHandle = async (mobile) => {
    try {
      const { data } = await Donation_bill_Details_Public(mobile, orgId);
      if (data?.status === 200) {
        let payload = data.payload.data;
        if (payload !== null && payload !== undefined) {
          setPersonaId(payload.personId ? payload.personId : null);
          setName(payload.name ? payload.name : null);
          setVillage(payload.village ? payload.village : null);
          setPanCard(payload.panCardNo ? payload.panCardNo : null);
          setAadhaarCard(payload.aadhaarCard ? payload.aadhaarCard : null);
          setCity(payload.city ? payload.city : null);
          setState(payload.state ? payload.state : null);
          setCountry(payload.country ? payload.country : null);
          setAddress(payload.address ? payload.address : null);
          setDate(payload.dob ? new Date(DateFormateChange(payload.dob)) : null);
        } else {
          return true;
        }
      } else {
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const emptyUserDetails = () => {
    setName('');
    setVillage('');
    setPanCard('');
    setAadhaarCard('');
    setCity('');
    setState('');
    setCountry('');
    setAddress('');
  };

  const handleContactChange = async (e) => {
    setContactNo(e.target.value);
    if (e.target.value.length === 10) {
      showHandle(`${dialCode} ${e.target.value}`);
    } else {
      emptyUserDetails();
    }
  };

  const handleChangeDialCode = async (e) => {
    const { value } = e.target;
    if (value && contactNo?.length === 10) {
      const isEmpty = await showHandle(`${value} ${contactNo}`);
      if (isEmpty && typeof isEmpty === 'boolean') {
        emptyUserDetails();
      }
    }
    setDialCode(value);
  };

  const emplyFeild = () => {
    setPersonaId('');
    setDialCode('+91');
    setContactNo('');
    setName('');
    setVillage('');
    setPanCard('');
    setAadhaarCard('');
    setAddress('');

    setFeilds((prev) => {
      const updated = [...prev];
      updated[0] = {
        ...updated[0],
        accountId: updated[0].accountId,
        amount: Number(updated[0].amount),
        totalAmount: Number(updated[0].amount),
        name: updated[0].name,
        unit: updated[0].unit,
        unitValue: Number(1)
      };
      return updated;
    });
    setNote('');
    setTransectionNo('');
    setByhand('');
    setCity('');
    setState('');
    setCountry('');
    setTrustId('');
    setDate('');
  };

  const pageItemUploadFile = async ({ files, type }) => {
    let formData1 = new FormData();
    formData1.append('type', type);
    formData1.append('file', files[0]);

    try {
      const { data } = await FILE_API(formData1);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });

        return {
          imageUrl: data.payload.imageUrl,
          baseUrl: data.payload.baseUrl
        };
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setClick(!click);
    let donationArray = feilds.map(({ accountId, amount, totalAmount }) => ({
      accountId,
      amount: Number(totalAmount)
    }));
    try {
      let formData = isEmpty({
        personId: personId,
        mobile: `${dialCode} ${contactNo}`,
        name,
        village: village,
        donationArray,
        bankId,
        note,
        transactionNo: transectionNo,
        byHand,
        city,
        orgId,
        templeId: templeUuid,
        state,
        trustId: trustUuid,
        dob: moment(date).format('yyyy-MM-DD'),
        paymentType: 'UPI',
        paymentMode: 'Bank'
      });

      if (e.target.screenShort && e.target.screenShort.files.length > 0) {
        const { imageUrl } = await pageItemUploadFile({
          files: e.target.screenShort.files,
          type: CLIENT_TYPE.PUBLIC_FORM
        });
        formData['attachment'] = imageUrl;
      }
      const { data } = await CreateTrasectionDueSlip_Public(formData);
      if (data.status === 200) {
        setClick(false);
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
        emplyFeild();
        history(`/Thankyou/${orgId}/${templeUuid}/${trustUuid}/${bankId}/${accontId}`);
        setClick(false);
      } else {
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setClick(false);
    }
  };
  const handleInputChangeUnitRadio = (i, e) => {
    const values = [...feilds];

    const val = Number(e.target.value); // convert to number

    // Set unitValue manually (since radio name is different)
    values[i]['unitValue'] = val;

    // Calculate total
    values[i]['totalAmount'] = val * Number(values[i]['amount']);

    setFeilds(values);

    // Set note
    setNote(val + ' ' + values[i].unit + ' ' + values[i].name + ' ના ' + values[i]['totalAmount']);
  };

  const TotalAmount = () => {
    let total = 0;
    for (let amount of feilds) {
      total += +amount.amount;
    }
    return total;
  };

  return (
    <div className="panel">
      {click === true || (loading === true && <CustomLoader />)}
      <div className="backGround">
        <DonarPublicHeaderComponent secondTitle="#000000ff" therdTitle="black" />
        <Col sm="12" className="container" style={{ paddingTop: '0rem', paddingBottom: '0rem' }}>
          <Card className="backgroundcolor text-black text-start">
            <CardBody>
              <Row>
                <Col sm="12">
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom01">{'Contact No. (ફોન નંબર/संपर्क नंबर)*'}</Label>
                        <div className="d-flex">
                          <select
                            className="form-control"
                            style={{ width: '67px' }}
                            onChange={(e) => {
                              handleChangeDialCode(e);
                            }}
                            value={dialCode}
                          >
                            <option value={''}>{'-- select --'}</option>{' '}
                            {dialCodeJson.map((elem) => {
                              return <option value={elem.code}>{elem.country}</option>;
                            })}
                          </select>
                          <Input
                            className="form-control colorBlack"
                            name="contactno"
                            type="number"
                            id="contactno"
                            placeholder={'Contact No.'}
                            min={0}
                            maxLength={10}
                            onInput={maxLengthCheck}
                            value={contactNo}
                            onChange={(e) => handleContactChange(e)}
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                        </div>
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom01">{'Name (નામ/नाम)*'}</Label>
                        <Input
                          className="form-control colorBlack"
                          name="contactno"
                          type="text"
                          id="contactno"
                          placeholder={'Name'}
                          value={name}
                          onChange={(e) => setName(toCamelCase(e.target.value))}
                          required
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom01">{'Village (ગામ/गाँव)*'}</Label>
                        <Input
                          className="form-control colorBlack"
                          name="contactno"
                          type="text"
                          id="contactno"
                          placeholder={'Village'}
                          value={village}
                          onChange={(e) => setVillage(toCamelCase(e.target.value))}
                          required
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="3 mb-4">
                        <Label htmlFor="validationCustom01">{'By Hand (હસ્તક/हाथ से)'}</Label>
                        <Input
                          className="form-control colorBlack"
                          name="contactno"
                          type="text"
                          id="contactno"
                          placeholder={'By Hand'}
                          value={byHand}
                          onChange={(e) => setByhand(toCamelCase(e.target.value))}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="3 mb-4">
                        <Label htmlFor="validationCustom01">{'Birth Date (જન્મ તારીખ/जन्म तिथि)*'}</Label>
                        <DatePicker
                          className="form-control"
                          selected={date}
                          onChange={(date) => setDate(date)}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="DD-MM-YYYY"
                          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                          isClearable
                          required
                        />
                        {/* <Input
                          className="form-control"
                          name="totalamount"
                          type="date"
                          id="totalamount"
                          placeholder="dd-mm-yyyy"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        /> */}
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md="3 mb-4">
                        <Label htmlFor="validationCustom01">{'Taluka (તાલુકો/तालुका)'}</Label>{' '}
                        <Input
                          className="form-control colorBlack"
                          name="contactno"
                          type="text"
                          id="contactno"
                          placeholder={'Taluka'}
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="3 mb-4">
                        <Label htmlFor="validationCustom01">{'District (જિલ્લો/जिला)'}</Label>{' '}
                        <Input
                          className="form-control colorBlack"
                          name="contactno"
                          type="text"
                          id="contactno"
                          placeholder={'District'}
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>

                    <hr style={{ color: 'cadetblue', border: '2px solid' }} />

                    <>
                      {feilds.map((elem, i) => (
                        <div key={elem.id}>
                          <Row>
                            <Col md="12 mb-12">
                              <Label htmlFor="validationCustom01">
                                {'Donation Type '}:<span className="fw-bold fs-5">{elem.name}</span>
                              </Label>
                            </Col>
                            {/* <Col md="5 mb-4">
                               <Label htmlFor="validationCustom01" className='fw-bold '>{elem.unit ?? 'N/A'}</Label>
                               <Input
                                className="form-control colorBlack"
                                name="unitValue "
                                type="number"
                                id="unitValue"
                                value={elem.unitValue}
                                onChange={(e) => handleInputChangeUnit(i, e)}
                                placeholder={elem.unit}
                                onWheel={(e) => e.target.blur()}
                              />
                              
                            </Col> */}
                            <Col md="5 mb-4">
                              <Label className="fw-bold fs-5">{elem.unit ?? 'N/A'}</Label>

                              <div className="d-flex flex-wrap gap-2 mt-2">
                                {[...Array(maxUnit)].map((_, index) => {
                                  const val = index + 1;

                                  return (
                                    <div key={val} className="form-check form-check-inline">
                                      <Input
                                        type="radio"
                                        className="form-check-input"
                                        name={`unitValue-${i}`}
                                        id={`unitValue-${i}-${val}`}
                                        value={val}
                                        checked={Number(elem.unitValue) === val}
                                        onChange={(e) => handleInputChangeUnitRadio(i, e)}
                                      />

                                      <Label className="form-check-label" htmlFor={`unitValue-${i}-${val}`}>
                                        {val}
                                      </Label>
                                    </div>
                                  );
                                })}

                                {/* Add More Button */}
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary p-1 d-flex align-items-center justify-content-center"
                                  style={{ width: '28px', height: '28px' }}
                                  onClick={() => setMaxUnit((prev) => prev + 5)}
                                >
                                  <Plus size={16} />
                                </button>
                              </div>
                            </Col>

                            <Col md="5 mb-4">
                              <Label htmlFor="validationCustom01">{'Total Amount *'}</Label>
                              <Input
                                className="form-control colorBlack"
                                name="totalAmount"
                                type="number"
                                id="totalAmount"
                                value={elem.totalAmount === 0 ? '' : elem.totalAmount}
                                onChange={(e) => handleInputChange(i, e)}
                                placeholder={'totalAmount'}
                                onWheel={(e) => e.target.blur()}
                                disabled={true}
                              />
                              <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                            </Col>
                            <Col
                              md="2 mb-4"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                top: '12px'
                              }}
                            ></Col>
                          </Row>
                        </div>
                      ))}

                      <Row>
                        <Col md="12 mb-4">
                          <Label htmlFor="validationCustom01">{'Note'}</Label>
                          <textarea
                            className="form-control colorBlack"
                            name="note"
                            id="note"
                            placeholder={'Note'}
                            rows="3"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                          />
                          <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                        </Col>
                      </Row>
                    </>

                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={click === true ? true : false}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default DonationMahotsavType;
